<template>
  <div class="colorDiv">
    <Form class="cs-them-drawer" :model="formItem" :label-width="220">
      <Form-item label="菜单字体颜色">
        <ColorPicker class="cs-color-picker" v-model="formItem.menuFonColor" />
      </Form-item>
      <Form-item label="菜单颜色渐变1">
        <ColorPicker
          class="cs-color-picker"
          v-model="formItem.menuBackgroundOne"
        />
      </Form-item>
      <Form-item label="菜单颜色渐变2">
        <ColorPicker
          class="cs-color-picker"
          v-model="formItem.menuBackgroundTow"
        />
      </Form-item>
      <Form-item label="菜单渐变角度">
        <Input class="cs-color-picker" v-model="formItem.menuDegree" />
      </Form-item>
      <Form-item label="二级菜单展开颜色">
        <ColorPicker
          class="cs-color-picker"
          v-model="formItem.secondMenuBackground"
        />
      </Form-item>
      <Form-item label="鼠标移动">
        <ColorPicker class="cs-color-picker" v-model="formItem.menuItemHover" />
      </Form-item>
      <Form-item label="鼠标选中">
        <ColorPicker
          class="cs-color-picker"
          v-model="formItem.menuItemActive"
        />
      </Form-item>
      <Form-item label="二级菜单中的一级菜单颜色">
        <ColorPicker
          class="cs-color-picker"
          v-model="formItem.secondMenuItemOne"
        />
      </Form-item>
      <Form-item label="页面整体颜色">
        <ColorPicker class="cs-color-picker" v-model="formItem.themColor" />
      </Form-item>
    </Form>

    <div class="them-drawer-footer">
      <Button style="margin-right: 8px" @click="onCancel">取消</Button>
      <Button type="primary" @click="onSubmit">确定</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    themInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      formItem: {
        // 菜单渐变角度
        menuDegree: -180,
        // 菜单字体颜色
        menuFonColor: "#fff",
        //菜单颜色 渐变1
        menuBackgroundOne: "#006B37",
        //菜单颜色 渐变2
        menuBackgroundTow: "#31674D",
        //二级菜单展开颜色
        secondMenuBackground: "#315635",
        //鼠标移动
        menuItemHover: "#459846",
        //鼠标选中
        menuItemActive: "#5BBF5D",
        //二级菜单中的一级菜单颜色
        secondMenuItemOne: "#459846",
        // 页面整体颜色
        themColor: "#459846"
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$props.themInfo.id && (this.formItem = this.$props.themInfo);
    });
  },
  methods: {
    onCancel() {
      this.$emit("onCancel");
    },
    onSubmit() {
      this.$emit("onSubmit", this.formItem);
      this.setThem();
    },
    setThem() {
      let bodyStyle = document.getElementsByTagName("body")[0].style;
      if (this.formItem && this.formItem.id) {
        bodyStyle.setProperty("--menuDegree", this.formItem.menuDegree + "deg");
        bodyStyle.setProperty("--menuFonColor", this.formItem.menuFonColor);
        bodyStyle.setProperty(
          "--menuBackgroundOne",
          this.formItem.menuBackgroundOne
        );
        bodyStyle.setProperty(
          "--menuBackgroundTow",
          this.formItem.menuBackgroundTow
        );
        bodyStyle.setProperty(
          "--secondMenuBackground",
          this.formItem.secondMenuBackground
        );
        bodyStyle.setProperty("--menuItemHover", this.formItem.menuItemHover);
        bodyStyle.setProperty("--menuItemActive", this.formItem.menuItemActive);
        bodyStyle.setProperty(
          "--secondMenuItemOne",
          this.formItem.secondMenuItemOne
        );
        bodyStyle.setProperty("--themColor", this.formItem.themColor);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.colorDiv {
  zoom:1.25 !important
}
/deep/.ivu-select-dropdown {
  width: 120% !important;
}
.cs-them-drawer {
  width: 80%;
  margin: auto;
}
.them-drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
.cs-color-picker {
  width: 200px;
}
/deep/ .ivu-input-default .ivu-color-picker-color {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/layouts/themDrawer.vue